<!-- NavItem.vue -->
<template>
  <div class="group relative">
    <button
      v-on:click="router.push(href)"
      :class="isActive ? 'bg-[#ffffff99]' : ''"
      class="flex h-16 w-16 cursor-pointer flex-col items-center justify-center rounded-xl text-xs transition-all duration-200 hover:bg-[#ffffff66] focus:outline-none md:flex-row"
    >
      <span class="text-3xl">
        <component :class="isActive ? 'text-neutral-500' : 'text-neutral-400'" :is="icon" />
      </span>
    </button>
    <!-- Tooltip -->
    <div
      class="font-fredoka pointer-events-none absolute top-1/2 left-full z-10 ml-2 hidden -translate-y-1/2 rounded-xl bg-gray-800 px-8 py-4 text-lg whitespace-nowrap text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100 md:block"
    >
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import router from '../router';
import { useRoute } from 'vue-router';
import { ref, type Ref, watch } from 'vue';

const route = useRoute();
const isActive: Ref<boolean> = ref<boolean>(false);
const props = defineProps<{ icon: any; label: string; href: string; paths?: string[] }>();

function checkActive() {
  isActive.value =
    route.path.startsWith(props.href) ||
    (props.paths != undefined && props.paths.filter((e) => route.path.startsWith(e)).length > 0);
}

watch(route, checkActive);
checkActive();
</script>
